import { useEffect, useState } from "react";
import { MdLocationPin, MdOutlineArrowDropDown } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import MapSearch from "../../../Helper/MapSearch";
import { fetchAddress, setAddress } from "../../../Redux/State-slice/Location";
import ReuseableModel from "../../Modal/ReuseableModel";
import AnotherSearchLocation from "../AnotherSearchLocation";
// import { IsMobile } from "../../../Helper/FormHelper";
import useIsMobile from "../../../customHooks/useIsMobile";

const ShowLocation = ({ setUserAddress, userAddress }) => {
  const dispatch = useDispatch();
  const { coordinate, address } = useSelector((state) => state.location);

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (coordinate) {
      dispatch(fetchAddress(coordinate));
    }
  }, [dispatch]);

  useEffect(() => {
    const storedLocation = JSON.parse(localStorage.getItem("location"));
    if (storedLocation) {
      // dispatch(setCoordinates({ lat: storedLocation.latitude, lon: storedLocation.longitude }));
      setUserAddress(storedLocation.address);
    }
  }, [address]);

  /**
   * `place` comes from Mapbox with its coordinates attached, so the chosen
   * location is stored directly — no follow-up geocoding request.
   */
  const handleSelect = (place) => {
    if (!place) return;
    setUserAddress(place.address);
    dispatch(
      setAddress({
        address: place.address,
        lat: place.lat,
        lon: place.lng,
        area: place.area || "",
        city: place.city || "",
        state: place.state || "",
        country: place.country || "",
      }),
    );
    setShow(false);
  };

  const handleClose = () => setShow(false);
  const isMobile = useIsMobile();
  return (
    <>
      <div className="d-flex w-100 justify-content-center text-white py-2 px-2" style={{ background: "#1B6DC1" }}>
        {userAddress ? (
          <div className="d-flex gap-1" onClick={() => setShow(true)}>
            <MdLocationPin size={20} />

            {isMobile ? `${userAddress.slice(0, 30)}...` : userAddress}


            <MdOutlineArrowDropDown size={20} />
          </div>
        ) : (
          <AnotherSearchLocation userAddress={userAddress} setUserAddress={setUserAddress} handleSelect={handleSelect} />
        )}
      </div>
      <ReuseableModel show={show} handleClose={handleClose} title={"Point your location"}>
        {/* Mounted only while open, so the Mapbox chunk is fetched when the
            customer actually opens the picker — not on every page load. */}
        {show && (
          <MapSearch
            coordinate={coordinate}
            userAddress={userAddress}
            handleSelect={handleSelect}
            setUserAddress={setUserAddress}
          />
        )}
      </ReuseableModel>
    </>
  );
};

export default ShowLocation;
